import React, { Component } from "react";
import PropTypes from "prop-types";

import LineSeries from "./LineSeries";

class NVISeries extends Component {
  constructor(props) {
    super(props);
    this.yAccessorForNVI = this.yAccessorForNVI.bind(this);
    this.yAccessorForMA = this.yAccessorForMA.bind(this);
  }
  yAccessorForNVI(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).nvi;
  }
  yAccessorForMA(d) {
    const { yAccessor } = this.props;
    return yAccessor(d) && yAccessor(d).nviMA;
  }
  render() {
    const { className, onDoubleClick, onContextMenu } = this.props;

    const { strokeNVI, strokeMA } = this.props;

    const { clip } = this.props;

    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.yAccessorForNVI}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeNVI}
          clip={clip}
        />
        <LineSeries
          yAccessor={this.yAccessorForMA}
          highlightOnHover
          onDoubleClick={onDoubleClick}
          onContextMenu={onContextMenu}
          stroke={strokeMA}
          clip={clip}
        />
      </g>
    );
  }
}

NVISeries.propTypes = {
  className: PropTypes.string,
  yAccessor: PropTypes.func.isRequired,
  clip: PropTypes.bool.isRequired,
  strokeNVI: PropTypes.object.isRequired,
  strokeMA: PropTypes.object.isRequired,
  onDoubleClick: PropTypes.func,
  onContextMenu: PropTypes.func,
};

NVISeries.defaultProps = {
  className: "react-stockcharts-nvi-series",
  clip: true,
};

export default NVISeries;
